import React from 'react';
import { ProgressBar, ProgressValue } from './VideoProgress.styles';

const VideoProgress = ({ percent, hidden }) => {
    if (!percent) {
        return null;
    }

    return (
        <ProgressBar
            percent={percent}
            hidden={hidden}
            aria-label="Förloppsindikator"
            role="progressbar"
            aria-valuetext={`Du har sett ${Math.round(percent)}% av programmet`}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-valuenow={percent}
        >
            <ProgressValue percent={percent} />
        </ProgressBar>
    );
};

export default VideoProgress;
